import { getProcedureDateInfoDetailed, formatTimeZoneDate, timeZoneDateToTime, nullishFilter } from '@caresend/utils';
import { tz } from 'dayjs';
import '@caresend/types';
import '@sentry/vue';
import { toastErrorAndReport } from '../../../functions/toast/toast.js';
import '@fortawesome/fontawesome-svg-core';
import 'buefy';
import '../../../components/ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';

function getProcedureDateTimeInfo(procedure) {
    var _a, _b, _c, _d;
    if (!procedure.dateInfo)
        return { creation: '', requested: [] };
    const requested = getProcedureDateInfoDetailed(procedure);
    let creation;
    if (procedure.creationTimestamp !== undefined) {
        const timeZone = (_d = (_c = (_b = (_a = procedure.dateInfo) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.dateInstruction) === null || _c === void 0 ? void 0 : _c.timeZone) !== null && _d !== void 0 ? _d : tz.guess();
        const creationTzDate = {
            timeZone,
            timestamp: procedure.creationTimestamp,
        };
        creation = `${formatTimeZoneDate(creationTzDate, 'MM/DD/YYYY')} at ${timeZoneDateToTime(creationTzDate)}`;
    }
    return {
        creation,
        requested,
    };
}
const getOrderProcedures = (orderID, rootState) => {
    var _a, _b;
    return Object.values((_b = (_a = rootState.orders.orders[orderID]) === null || _a === void 0 ? void 0 : _a.bookings) !== null && _b !== void 0 ? _b : {}).reduce((_procedures, currentBooking) => {
        var _a, _b, _c;
        return ([
            ...Object.values((_c = (_b = (_a = rootState.bookings) === null || _a === void 0 ? void 0 : _a.bookings[currentBooking.id]) === null || _b === void 0 ? void 0 : _b.procedures) !== null && _c !== void 0 ? _c : {})
                .map(({ id }) => rootState.procedures.procedures[id])
                .filter(nullishFilter),
        ]);
    }, []);
};
const getProcedureHasReAttempt = (procedureID, rootState) => { var _a; return !!((_a = rootState.procedures.procedures[procedureID]) === null || _a === void 0 ? void 0 : _a.rescheduledID); };
/**
 * Checks a sample path in the store. Use before using the `update` helper to
 * update a sample, to ensure data to update exists.
 */
const sampleExists = (state, procedureID, sampleID) => {
    var _a, _b;
    const sample = (_b = (_a = state.procedures[procedureID]) === null || _a === void 0 ? void 0 : _a.samples) === null || _b === void 0 ? void 0 : _b[sampleID];
    if (!sample) {
        toastErrorAndReport(`Missing sample ${sampleID} on procedure ${procedureID}`);
        return false;
    }
    return true;
};

export { getOrderProcedures, getProcedureDateTimeInfo, getProcedureHasReAttempt, sampleExists };
